import { z } from "zod";
export const updateSwiklyIntegrationSchema = z.object({
    api_key: z.string().min(1),
});
